import * as Switch from '@radix-ui/react-switch';
import styles from './toggle.module.scss';
import classNames from 'classnames';

interface ToggleProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  label?: string;
}

const Toggle = ({checked, onChange, disabled, className, label}: ToggleProps) => {
  return (
    <div className={classNames(styles.container, className)}>
      <Switch.Root
        className={styles.switch}
        checked={checked}
        onCheckedChange={onChange}
        disabled={disabled}
      >
        <Switch.Thumb className={styles.thumb} />
      </Switch.Root>
      {label && <span className={styles.label}>{label}</span>}
    </div>
  );
};

export default Toggle;
